import { useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

import { jobTitleList } from '@feature/utils';

export type JobTitleSelectControlProps<T extends FieldValues> = Omit<EnumSelectControlProps<T>, 'options'>;

export function JobTitleSelectControl<T extends FieldValues>(props: JobTitleSelectControlProps<T>) {
  const { t } = useTranslation();
  const options = useMemo(() => jobTitleList.map(c => ({ value: c, label: t(`jobTitleEnum.${c}`) })), [t]);

  return (
    <EnumSelectControl
      {...props}
      options={options}
    />
  );
}
